module.exports = __webpack_public_path__ + "static/img/bg_cloud.a0a65113.jpg";